import { useDeleteUser } from 'api/services/userService';
import { useTranslation } from 'react-i18next';
import { useFloatNotification } from 'contexts/FloatNotificationContext';
import { GenericDeleteModal } from 'components/ui/GenericDeleteModal';

interface DeleteUserModalProps {
  open: boolean;
  onCancel: () => void;
  companyId?: string;
  userCompanyRoleId?: string;
}

export const DeleteUserModal = ({
  open,
  onCancel,
  companyId = '',
  userCompanyRoleId = '',
}: DeleteUserModalProps) => {
  const { t } = useTranslation();
  const { mutateAsync: deleteUser, isPending } = useDeleteUser();
  const { openNotification } = useFloatNotification();

  const handleDelete = async () => {
    try {
      await deleteUser({
        companyId,
        userCompanyRoleId,
      });

      openNotification(
        t('users-page.users-list.delete-user-modal.success-notification-title'),
        t(
          'users-page.users-list.delete-user-modal.success-notification-message'
        ),
        'success'
      );
    } catch {
      openNotification(
        t('users-page.users-list.delete-user-modal.error-notification-title'),
        t('users-page.users-list.delete-user-modal.error-notification-message'),
        'error'
      );
    }

    onCancel();
  };

  return (
    <GenericDeleteModal
      open={open}
      onCancel={onCancel}
      onOk={handleDelete}
      confirmLoading={isPending}
      bodyText={t('users-page.users-list.delete-user-modal.body')}
    />
  );
};
